<template>
    <div class="full-width">
        <ul class="back-info-ul">
            <li>
                <pageTitle :titleText="i18n.tkey('lang_link_company')" />
            </li>

            <li>
                <cardCompanyContactList :card="card" :recordIdStr="card.inputby" />
            </li>

            <li>
                <pageTitle :titleText="i18n.tkey('lang_link_personal')" />
            </li>

            <li>
                <cardPersonContactList :card="card" :recordIdStr="card.addinfo1" />
            </li>
        </ul>
    </div>
</template>

<script setup>

    import {inject, onMounted} from "vue";
    import cardCompanyContactList from "@/components/shopopee/card/cardCompanyContactList"
    import cardPersonContactList from "@/components/shopopee/card/cardPersonContactList"
    import pageTitle from "@/components/shopopee/common/pageTitle"

    const props = defineProps(["card"])

    const i18n = inject("i18n")

    onMounted(() => {

    })

</script>

<style scoped>
    .full-width {
        width: 100%;
    }

    .back-info-ul {
        padding-left: 0;
        list-style: none;
    }
</style>